import { Button } from '@/components/ui/Button'
import { Menu, Portal } from '@chakra-ui/react'
import { useTranslation } from 'react-i18next'

/**
 * LanguageSwitcher Component
 * Dropdown menu for switching between languages
 */
export function LanguageSwitcher() {
  const { i18n } = useTranslation()

  const languages = [
    { code: 'uk', nativeName: 'Українська', shortName: 'UA', flag: '🇺🇦' },
    { code: 'en', nativeName: 'English', shortName: 'EN', flag: '🇬🇧' },
  ]

  const currentLanguage = languages.find((lang) => lang.code === i18n.language) || languages[0]

  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng)
  }

  return (
    <Menu.Root>
      <Menu.Trigger asChild>
        <Button
          variant="ghost"
          px={3}
          py={2}
          height="auto"
          color="#42526E"
          _hover={{ bg: '#F4F5F7' }}
          display="flex"
          alignItems="center"
          gap={2}
        >
          <span>{currentLanguage.flag}</span>
          <span style={{ fontSize: '14px' }}>{currentLanguage.nativeName}</span>
        </Button>
      </Menu.Trigger>

      <Portal>
        <Menu.Positioner>
          <Menu.Content
            bg="white"
            borderRadius="3px"
            boxShadow="0 4px 8px rgba(9, 30, 66, 0.25)"
            border="1px solid #DFE1E6"
            minW="180px"
            p={1}
          >
            {languages.map((lang) => (
              <Menu.Item
                key={lang.code}
                value={lang.code}
                onClick={() => changeLanguage(lang.code)}
                bg={i18n.language === lang.code ? '#DEEBFF' : 'transparent'}
                color="#172B4D"
                fontSize="14px"
                px={3}
                py={2}
                borderRadius="3px"
                cursor="pointer"
                _hover={{ bg: '#F4F5F7' }}
                display="flex"
                alignItems="center"
                gap={2}
              >
                <span>{lang.flag}</span>
                <span>{lang.nativeName}</span>
              </Menu.Item>
            ))}
          </Menu.Content>
        </Menu.Positioner>
      </Portal>
    </Menu.Root>
  )
}

export default LanguageSwitcher
